import React from "react";
import Modal from "../../components/Modal";
import i18n from "../../i18n";
import {pwAssetUrl} from "../../utils/etc";
import TouchEffect from "../../components/TouchEffect/TouchEffect";
import styled from "styled-components";
import {genderKeys} from "../../photolab/etc";

const colors = [
  {id: "black", text: "Brunette", color: "#000"},
  {id: "red", text: "Red", color: "#d66506"},
  {id: "blonde", text: "Blonde", color: "#fcf4cb"},
  {id: "brunette", text: "Brown", color: "#533e3c"},
  {id: "light brown", text: "Light brown", color: "#96877d"},
  {id: "gray", text: "Gray", color: "#cecece"},
  {id: "other", text: "Other", color: "linear-gradient(-220deg, #97ffff, #f977c4)"},
];

const hairs = {
  female: [
    {
      text: "buzz-cut",
      value: "buzz cut hair",
    },
    {
      text: "pixie-cut",
      value: "pixie cut hair",
    },
    {
      text: "bob",
      value: "bob cut hair",
    },
    {
      text: "normal",
      value: "normal hair",
    },
    {
      text: "long",
      value: "long hair",
    },
  ],
  male: [
    {
      text: "bald",
      value: "bald head",
    },
    {
      text: "buzz-cut",
      value: "buzz cut hair",
    },
    {
      text: "crew",
      value: "crew cut hair",
    },
    {
      text: "normal",
      value: "normal hair",
    },
    {
      text: "long",
      value: "long hair",
    },
  ],
};

export default class HairColorStyleModal extends Modal {

  state = {
    activeColor: null,
    activeStyle: null,
    errors: {},
  };

  componentDidMount() {
    this.setState({
      activeColor: this.props.hairColor || "other",
    });
  }

  handleSubmitChosen = (isSkip) => {
    const {activeColor, activeStyle} = this.state;

    const isValid = activeColor && activeStyle;

    if (isValid || isSkip) {
      let hairStyle = activeStyle;

      if (!hairStyle) {
        const randomHairId = this.props.gender === genderKeys.male
          ? ["long", "normal", "crew", "buzz-cut"].random()
          : ["long", "normal", "bob"].random();

        hairStyle = hairs[this.props.gender].find((hair) => hair.text === randomHairId).value;
      }

      this.props.onColorSelect && this.props.onColorSelect(activeColor, hairStyle);
      this.dismiss();
      return;
    }

    this.setState({
      errors: {
        ...(!activeColor && {colorError: i18n.t("hair_color_style_modal__error_color")}),
        ...(!activeStyle && {styleError: i18n.t("hair_color_style_modal__error_style")})
      }
    });
  };

  handleSkipButtonClick = () => {
    this.handleSubmitChosen(true);
  }

  handleColorClick = (color) => {
    const {errors} = this.state;

    if (errors.colorError) {
      delete errors.colorError;
    }

    this.setState({
      activeColor: color,
      errors: errors
    });
  }

  handleStyleClick = (style) => {
    const {errors} = this.state;

    if (errors.styleError) {
      delete errors.styleError;
    }

    this.setState({
      activeStyle: style,
      errors: errors
    });
  }

  renderModal() {
    const {activeColor, activeStyle, errors} = this.state;

    return (
      <React.Fragment>
        <h1 dangerouslySetInnerHTML={{__html: i18n.t("hair_color_style_modal__title")}} />
        <div className="container">
          <div className="hair-color__container">
            {errors.colorError && <p className="error-message">{errors.colorError}</p>}
            {colors.map((color) => <button
              key={color.id}
              className={`color-btn ${color.id === activeColor ? "active" : ""}`}
              onClick={() => this.handleColorClick(color.id)}>
              <div style={{background: color.color}}>
                <TouchEffect dark />
              </div>
              <p>{color.text}</p>
            </button>
            )}
          </div>
          <div className="hair-style__container">
            {errors.styleError && <p className="error-message">{errors.styleError}</p>}
            {hairs[this.props.gender].map((item, index) => (
              <button
                className={`style-btn ${item.value === activeStyle ? "active" : ""}`}
                onClick={() => this.handleStyleClick(item.value)}
                key={index}>
                <img src={pwAssetUrl(`hair-modal/${this.props.gender}/${activeColor ? colors.find((c) => c.id === activeColor).text.toLowerCase().replace(" ", "_") : "disabled"}/${item.text}.webp`)} alt="" />
                <TouchEffect />
              </button>
            ))}
          </div>
        </div>
        <ButtonStyled
          arrow
          animate={activeColor && activeStyle}
          transparent={!activeColor || !activeStyle}
          className={!activeColor || !activeStyle ? "disabled" : ""}
          full={activeColor && activeStyle}
          onClick={this.handleSubmitChosen}
          style={{maxWidth: "62%"}}
        >
          {i18n.t("hair_color_style_modal__proceed_button")}
          {/*<SvgMoreButtonArrowIcon color={!activeColor || !activeStyle ? "#4d5ef6" : "#fff"} />*/}
          <TouchEffect />
        </ButtonStyled>
        <ButtonStyled
          muted
          onClick={this.handleSkipButtonClick}
          className="skip-button"
          skip
          style={{maxWidth: "62%"}}
        >
          {i18n.t("hair_color_style_modal__skip_button")}
        </ButtonStyled>
      </React.Fragment>
    );
  }
}

export const ButtonStyled = styled.button`
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 0.32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  border: none;
  position: relative;
  height: 48px;
  max-width: 47%;
  width: 100%;
  margin: 0;
  overflow: hidden;

  .touch-effect {
    border-radius: 100px;
  }

  &[disabled], &.disabled {
    opacity: 0.5;

    .touch-effect {
        display: none;
    }
  }

  ${props => props.animate && `
    svg {
      width: 26px;
      fill: #000;
      animation: shake2 800ms infinite ease-out;
      margin-left: 10px;
    }

    @keyframes shake2 {
      0% {
        transform: translateX(-5px);
      }
      50% {
        transform: translateX(5px);
      }

      100% {
        transform: translateX(-5px);
      }
    }
  `}

  ${props => props.arrow && `
    svg {
      width: 26px;
      fill: #000;
      margin-left: 10px;
    }
  `}

  ${props => props.full && `
    font-weight: bold;
    color: #fff;
    background: #4d5ef6;

    &[disabled] {
      color: #4d5ef6;
      color: #fff;
      background: #4d5ef6;
    }
  `}

  ${props => props.transparent && `
    color: #4d5ef6;
    border: 1px solid #4d5ef6;
    background-color: transparent;

    &[disabled] {
      color: #4d5ef6;
      border: 1px solid #4d5ef6;
      background-color: transparent;
    }
  `}

  ${props => props.skip && `
    align-items: flex-end;
    background: none;
    height: auto;
    margin-top: 30px;
  `}
`;